module.exports = __webpack_public_path__ + "static/media/01.28c61ad4.png";